<template>
  <el-dialog :title="title" :visible="isShowAdd" @close='closeDialog' width='680px'
    :append-to-body="true"
    :destroy-on-close="true"
    :close-on-click-modal='false'>
      <el-form class="form-wrap" :model="info" ref="question" :rules="rules" label-width="100px">
        <el-form-item label="问题：" prop="question">
          <el-input v-model="info.question"  placeholder="请输入问题" maxlength="50" show-word-limit clearable></el-input>
        </el-form-item>
        <el-form-item label="关键词：" prop="keyWord">
          <el-input v-model="info.keyWord"  placeholder="请输入关键词，用英文逗号隔开" maxlength="20" show-word-limit clearable></el-input>
        </el-form-item>
        <el-form-item label="回答：" prop="answer">
          <el-input type="textarea" placeholder="请输入问题回答" v-model="info.answer"
            maxlength = "300"
            :rows="8"
            show-word-limit>
          </el-input>
        </el-form-item>
        <div class="form-item-btn">
          <el-button type="primary" @click="onSave" :disabled="disabled">保存</el-button>
          <el-button type="primary" @click="closeDialog">取消</el-button>
      </div>
      </el-form>
  </el-dialog>
</template>

<script>
export default {
  typeName: 'CustomerManageAdd',
  props: {
    id: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    isShowAdd: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      info: {
        question: '',
        keyWord: '',
        answer: ''
      },
      disabled: false,
      rules: {
        question: [
          { required: true, message: '请输入问题', trigger: 'blur' }
        ],
        keyWord: [
          { required: true, message: '请输入关键词，用英文逗号隔开', trigger: 'blur' }
        ],
        answer: [
          { required: true, message: '请输入问题回答', trigger: 'blur' }
        ]
      }
    }
  },
  created () {
    if (this.id) {
      this.getSetting()
    }
  },
  watch: {
  },
  computed: {
  },
  methods: {
    getSetting () {
      this.$axios.get(this.$apis.tourist.selectKfAnswerById, {
          id: this.id
      }).then(res => {
        this.info = res || {}
      })
    },
    onSave () {
      this.$refs.question.validate().then(() => {
        this.disabled = true
        const url = this.id ? this.$apis.tourist.updateKfAnswer : this.$apis.tourist.insertKfAnswer
        const params = {
          question: this.info.question,
          keyWord: this.info.keyWord,
          answer: this.info.answer
        }
        this.$axios.post(url, this.id ? { ...params, id: this.id } : params).then(res => {
          this.closeDialog()
          this.$emit('close')
        }).finally(() => {
          this.disabled = false
        })
      })
    },
    closeDialog () {
      this.info = {}
      this.$emit('update:isShowAdd', false)
      this.$emit('close')
    }
  }
}
</script>
<style scoped lang="scss">
::v-deep .el-form-item__content{
  width: 530px;
}
.choose{
  display: flex;
}
.form-item-btn{
  text-align: center;
  margin-top: 20px;
}
</style>
